var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.usertype === '1')?_c('DashboardUser'):(_vm.usertype === '2')?_c('DashboardRenter'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }